import React from 'react';
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';

// helpers
import { PUBLIC_IMG_URL, WEB_URL } from '/src/lib/endpoints';
import { amountFormatter } from "/src/lib/helpers";
import { formatDateFounded, formatEmployeeCount } from '/src/lib/fieldFormatters';
// reusable
import SocialTab from '../SocialTab';
import startupApi from '/src/apis/startupApi';
import axios from 'axios';
//constants
import { TECHNOLOGY_ICONS } from '/src/lib/constants';



export const getProfileLogo = (investor) => {
    const { logo_data, profile_pic_data, name, first_name } = investor;
    let logo;
    if (logo_data && !isEmpty(logo_data)) {
        logo = encodeURI(logo_data.path);
    } else if (!isEmpty(profile_pic_data)) {
        logo = encodeURI(profile_pic_data.path);
    }

    if (logo) {
        logo = `url("${logo}")`;
        logo = <div className="logoBlock" style={{ backgroundImage: logo }}></div>
    } else {
        let profileName = (name ? name : first_name);
        logo = <div className='logoBlock'><h2 style={{ fontSize: '5em' }}>{profileName.substr(0, 1).toUpperCase()}</h2></div>
    }
    return logo;
}

export const getProfileName = (investor) => {
    // name field
    let name = investor?.name;
    if (!name) {
        const firstName = investor?.first_name ? investor?.first_name : "";
        const lastName = investor?.last_name ? investor?.last_name : "";
        name = `${firstName} ${lastName}`;
    }
    return name;

}


export const getStartupBasicInfoCardDetails = (startup, businessType) => {

    const dateFounded = startup?.date_founded ? formatDateFounded(startup) : 'N/A';
    const employee_size = formatEmployeeCount(startup);

    let businessTypes;
    if (!isEmpty(businessType)) {
        businessTypes = [];
        businessType?.map(v => {
            if (!isEmpty(v.business_type_data)) {
                businessTypes?.push(v?.business_type_data?.name)
            }
        });

        businessTypes = [...new Set(businessTypes)];
        businessTypes = businessTypes?.filter(Boolean).join(", ");
    }

    const arrValues = [
        // {
        //     heading: 'Development stage',
        //     subheading: startup?.development_stage_data?.name || 'N/A'
        // },
        {
            heading: 'Business type',
            subheading: businessTypes || 'N/A'
        },
        {
            heading: 'Number of employees',
            subheading: employee_size || 'N/A'

        },
        {
            heading: 'Date Founded',
            subheading: dateFounded || 'N/A'

        }
    ];

    return removeEmptyValueCase(arrValues);
}

export const getStartupIndustryDetails = (startup, industries, subIndustries) => {
    let primaryIndustry = 'N/A';
    if (!isEmpty(industries)) {
        let index = findIndex(industries, { 'is_primary': 1 })
        if (index > -1) {
            primaryIndustry = isEmpty(industries[index]?.industry_data) ? 'N/A' : <VerificationPillBadgeToolTip pillColor='green' pillText={industries[index]?.industry_data?.name} isBasicPill />
        }
    }

    let subIndustry = 'N/A';
    if (!isEmpty(subIndustries)) {
        // sort sub industries by id
        let sortedInds = subIndustries?.sort((a, b) => {
            if (a?.id !== undefined && b?.id !== undefined) {
                return a.id - b.id;
            }
            return 0;
        })

        // Show the last entry in sub industry array as Sub Industry
        subIndustry = sortedInds[sortedInds.length - 1].industry_data?.name
    }

    // secondary industries
    let allIndustries = 'N/A'
    if (!isEmpty(industries)) {
        allIndustries = [];
        industries?.map(v => {
            if (!isEmpty(v.industry_data) && v?.is_primary !== 1) {
                allIndustries?.push(v?.industry_data?.name)
            }
        });

        allIndustries = [...new Set(allIndustries)];
        allIndustries = allIndustries?.filter(Boolean).join(", ");
    }

    const arrValues = [
        {
            heading: '',
            subheading: <span><i className="fa fa-industry mr-2"></i>Industry Focus</span>,
            isIconHeader: true
        },
        {
            heading: 'Primary Industry',
            subheading: primaryIndustry || 'N/A'
        },
        {
            heading: 'Sub-Industry',
            subheading: subIndustry || 'N/A'
        },
        {
            heading: 'Secondary Industries',
            subheading: allIndustries || 'N/A'
        }
    ];

    return removeEmptyValueCase(arrValues);
}

export const getTechnologiesUsed = (entityData) => {

    if (!entityData || !entityData?.technology_data || entityData?.technology_data?.length === 0) {
        return;
    }

    let content = [
        {
            heading: '',
            subheading: <span>Technologies Used</span>,
            isIconHeader: true
        }
    ];

    if (entityData?.technology_data && entityData.technology_data.length > 0) {

        entityData.technology_data.forEach(tech => {
            const iconClass = TECHNOLOGY_ICONS[tech.id] || 'fa fa-cog';
            content.push({
                heading: '',
                subheading: (
                    <span className='technology-item'>
                        <span className='icon-wrapper'>
                            <i className={`${iconClass} mr-2`}></i>
                        </span>
                        <span>{tech.name}</span>
                    </span>
                )
            });
        });
    } else {
        content.push({
            heading: '',
            subheading: 'N/A'
        });
    }

    return removeEmptyValueCase(content)
}

export const getSocialInfoDetails = (investor) => {

    if (!investor) {
        return;
    }

    let content = [
        {
            heading: '',
            subheading: <span><i className="fa fa-globe mr-2"></i>On The Web</span>,
            isIconHeader: true
        },
        {
            heading: '',
            subheading: investor["website"] && (
                <a href={investor["website"]} target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-link mr-2"></i>
                    {investor["website"].replace("http://", "")}
                </a>
            )
        },
    ]

    const hasSocialDetails = (investor["website"] || investor["twitter"] || investor["facebook"] || investor["linkedin"] || investor["ios_app_url"] || investor["android_app_url"]);

    // avoid displaying 'website' icon as the link is already shown above
    let tempInv = { ...investor };
    if (investor["website"]) {
        delete tempInv.website;
    }

    if (hasSocialDetails) {
        content.push({
            heading: '',
            subheading: (
                <div className='social-tab'>
                    <SocialTab object={tempInv} type="user"></SocialTab>
                </div>
            )
        })
    } else {
        content.push({
            heading: '',
            subheading: "N/A"
        })
    }

    return removeEmptyValueCase(content)

}

export const getLocationDetails = (investor, user) => {

    let hqCountry = 'N/A';
    let branches = 'N/A';
    const country = investor?.hq_data ? investor?.hq_data.name : null;
    const city = investor?.city_data ? investor?.city_data.name : null;

    if (user && user.is_loggedin) {
        if (city && country) {
            hqCountry = city + ", " + country;
        } else if (country) {
            hqCountry = country;
        } else if (city) {
            hqCountry = city;
        }

        if (!isEmpty(investor?.branch_data) && investor.branch_data.length > 0) {
            branches = investor.branch_data.map(v => v.name).join(', ');
        }
    } else {
        let lock = <><i className="fa fa-lock"></i>Login to unlock</>;
        hqCountry = lock;
        branches = lock;
    }

    const arrValues = [
        {
            heading: '',
            subheading: <span><i className="fa fa-map mr-2"></i>Location</span>,
            isIconHeader: true
        },
        {
            heading: 'Headquarters',
            subheading: hqCountry
        },
        {
            heading: 'Branches',
            subheading: branches
        }
    ]

    return removeEmptyValueCase(arrValues)
}

export const findMostPopularIndustry = (data) => {
    // Default most popular industry to the first industry in the first data item
    let mostPopularIndustry = (data && data[0]?.industry_data && data[0]?.industry_data[0]?.name || null);

    const industryMap = {};
    data && data.forEach(item => {
        if (item.industry_data) {
            item.industry_data.forEach(industry => {
                const { name } = industry;
                industryMap[name] = (industryMap[name] || 0) + 1;
                if (industryMap[name] > industryMap[mostPopularIndustry]) {
                    mostPopularIndustry = name;
                }
            });
        }
    });

    return mostPopularIndustry;
}

//navigation helper functions

export const getPercentInView = (div) => {
    const rect = div.getBoundingClientRect();

    const dimension = { x: rect.x, y: rect.y, w: rect.width, h: rect.height };
    const viewport = { x: 0, y: 0, w: window.innerWidth, h: window.innerHeight };
    const divsize = dimension.w * dimension.h;
    const overlap = intersection(dimension, viewport);

    return ((overlap / divsize) * 100);
}

const intersection = (r1, r2) => {
    const xOverlap = Math.max(0, Math.min(r1.x + r1.w, r2.x + r2.w) - Math.max(r1.x, r2.x));
    const yOverlap = Math.max(0, Math.min(r1.y + r1.h, r2.y + r2.h) - Math.max(r1.y, r2.y));
    const overlapArea = xOverlap * yOverlap;
    return overlapArea;
}

// keep the active section button visible on mobile
export const handleMobileActiveSection = () => {
    try {
        if (window.innerWidth < MOBILE_BREAKPOINT) {
            // without the timeout, it interferes with scroll functionality
            setTimeout(() => {
                const stickyNav = document.querySelectorAll('.profile-nav-bar.sticky')
                if (stickyNav.length === 1) {
                    stickyNav[0].querySelectorAll('ul li a.active')[0].scrollIntoView()
                }
            }, 700);
        }
    } catch (err) { }
}

export const VerificationPillBadgeToolTip = ({ pillColor, pillText, hoverMessage, isBasicPill, isExitPill }) => (
    <div className="pill-badge-tooltip" data-toggle="tooltip" data-placement="right" title={hoverMessage}>
        <span className={`pill-badge pill-badge-${pillColor} `}>
            {!isBasicPill && <i className={"fa fa-bolt"} aria-hidden="true"></i>}
            {isExitPill && <i className={"fas fa-sign-out-alt"} aria-hidden="true"></i>}
            {pillText}
        </span>
    </div>
)

/**
 * Removes the vertical tab character (\u000B) from a string.
 * @param {string} str - The input string.
 * @returns {string} - The cleaned string.
 */
export const removeLineTabulationChars = (str) => {
    // eslint-disable-next-line no-control-regex
    return str.replace(/\u000b/g, '');
};

function removeEmptyValueCase(arr) {
    return arr.filter(item => item.subheading !== 'N/A' && item.subheading !== undefined);
}

export const getNewsLinks = (startupId, newsLinks, limit = 20, recursionDepth = 1) => {
    return startupApi.getStartupFundingNewsLinks(startupId, limit)
        .then(({ records, totalRecords }) => {
            const data = records || [];
            const total = totalRecords || 0;
            const notFound = '404';
            const initialFetchedDataCount = data.length;

            const defaultImg = `${PUBLIC_IMG_URL}/default-news-images/external_news_default_image.png`;

            const processedUrls = new Set();

            const isURL = (url) => {
                if (isEmpty(url)) return false;
                const pattern = /^(https?:\/\/|www\.)/i;
                return pattern.test(url);
            }

            const extractTitleFromUrl = (url) => {
                if (!isURL(url)) return null;
                const arrString = url.split('/');
                let title = arrString[arrString.length - 1];
                title = !title ? arrString[arrString.length - 2] : title;
                title = title.replace(/[-_]/g, ' ');
                title = title.split('?')[0].split('#')[0];

                if (/^\d+$/.test(title)) {
                    return null;
                }

                title = title.replace(/\b\w/g, char => char.toUpperCase());
                title = title.trim();
                return title;
            };

            const fetchNewsData = (newsUrl) => {
                return axios.get(`${WEB_URL}/api?url=${encodeURIComponent(newsUrl)}`)
                    .then(response => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(response.data, 'text/html');
                        const metaTitle = doc.querySelector('meta[property="og:title"]')?.content;
                        const pageTitle = doc?.querySelector('title')?.textContent || null;
                        const title = metaTitle || pageTitle || extractTitleFromUrl(newsUrl) || false;
                        const imgUrl = doc.querySelector('meta[property="og:image"]')?.content || defaultImg;

                        if (!title || title.includes(notFound)) {
                            return null;
                        }
                        return { title, imgUrl, newsUrl };
                    })
                    .catch(error => {
                        if (process.env.NODE_ENV === 'development') {
                            console.error(`Error fetching data from ${newsUrl}:`, error);
                        }

                        const title = extractTitleFromUrl(newsUrl);
                        const imgUrl = defaultImg;

                        if (!title || title.includes(notFound)) {
                            return null;
                        }
                        return { title, imgUrl, newsUrl };
                    });
            };

            const fetchPromises = data.flatMap(item => {
                const url = item.source_url
                if (isURL(url) && !processedUrls.has(url)) {
                    processedUrls.add(url);
                    return fetchNewsData(url).then(newsData => {
                        if (newsData) {
                            newsLinks.push(newsData);
                        }
                    });
                }
                return [];
            });

            return Promise.all(fetchPromises).then(() => {
                // fetch more data if newslinks are empty and there are more records to fetch for the startup
                if ((total - initialFetchedDataCount) > 0 && recursionDepth < 2) {
                    return getNewsLinks(startupId, newsLinks, total, recursionDepth + 1).then(moreNewsLinks => {
                        return newsLinks.concat(moreNewsLinks);
                    });
                }

                return newsLinks;
            });
        })
        .catch(error => {
            console.error('Error fetching news links:', error);
            return [];
        });
};


